export type InterpolationFunction = (interpolationValue: number) => void;

export enum InterpolationType {
  Linear,
  Ease,
}

export interface InterpolationOption {
  duration?: number;
  tickSize?: number;
  type?: InterpolationType;
}

export class Interpolation {
  private startTime: number;

  private intervalHandle: ReturnType<typeof setInterval>;
  constructor(
    private options: InterpolationOption,
    private onTickFunction: InterpolationFunction,
  ) {
    this.options.duration = this.options.duration || 1000;
    this.options.tickSize = this.options.tickSize || 10;
    this.options.type = this.options.type || InterpolationType.Linear;

    if (this.options.duration <= 0) {
      throw new Error('Duration have to be a none-zero positive value.');
    }

    if (this.options.tickSize <= 0) {
      throw new Error('Tick size have to be a none-zero positive value.');
    }

    this.startTime = Date.now();

    this.intervalHandle = setInterval(this.tick.bind(this), this.options.tickSize);
  }

  tick() {
    const deltaTime = Date.now() - this.startTime;
    let interpolationValue = deltaTime / this.options.duration!;
    if (interpolationValue >= 1.0) {
      interpolationValue = 1.0;
    }

    switch (this.options.type) {
      case InterpolationType.Ease:
        interpolationValue *= interpolationValue;
        break;
      // If Linear, do nothing
      case InterpolationType.Linear:
      default:
        break;
    }

    this.onTickFunction(interpolationValue);

    if (interpolationValue >= 1.0) {
      clearInterval(this.intervalHandle);
    }
  }
}
